import { render, staticRenderFns } from "./PurchaseForm.vue?vue&type=template&id=49a5f952&scoped=true"
import script from "./PurchaseForm.vue?vue&type=script&lang=js"
export * from "./PurchaseForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a5f952",
  null
  
)

export default component.exports